/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  const body = document.getElementById('body');

  // Set frontend version
  util.frontEndVersion = body.dataset.version;

  // Set debug mode
  util.debugMode = body.dataset.debugMode === 'true';

  // Set culture
  util.uiCulture = body.dataset.culture;

  // Set language
  util.uiLanguage = util.uiCulture ? util.uiCulture.split('-')[0] : null;

  // Set homepage Id
  util.homePageId = body.dataset.homepageId;

  // Set path
  util.path = body.dataset.path;

  if (util.debugMode) {
    console.info(util.uiCulture, util.uiLanguage, util.homePageId, util.path);
    if (!util.uiCulture) console.error('Culture is not set');
    if (!util.uiLanguage) console.error('Language is not set');
    if (!util.homePageId) console.error('HomePageId is not set');
    if (!util.path) console.error('Path is not set');
  }

  // Enable transitions
  document.documentElement.classList.remove('is-loading');

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initViewportDimensions();
  // app.general.initAnchorLinks();
  app.navigation.init();
  // app.navigation.initSearchBox();
  app.general.initEmailLinks();
  // app.general.initLax();
  app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  if (
    document.querySelectorAll('[data-carousel]').length > 0 ||
    document.querySelectorAll('[data-hero-carousel]').length > 0 ||
    document.querySelectorAll('[data-logo-carousel]').length > 0
  ) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/embla-carousel-autoplay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-video]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.videos' + min + '.js'), () => {
      app.videos.init();
    });
  }

  if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/videoLightbox' + min + '.js'), () => {
      const videos = document.querySelectorAll('[data-video-lightbox]');
      const lightbox = VideoLightbox(videos);

      window.addEventListener(
        'CookiebotOnAccept',
        (event) => {
          if (lightbox.hasMarketingConsent()) {
            lightbox.removeConsentWarning();
          }
        },
        false
      );
    });
  }

  if (document.querySelector('.searchResults')) {
    if (document.location.href.indexOf('?') > -1) {
      setTimeout(() => {
        document.querySelector('[data-results-anchor]').scrollIntoView({
          behavior: 'smooth',
        });
      }, 500);
    }
  }

  // ljs.load(
  //   util.getVersionedUrl('/scripts/dist/forms.newsletter' + min + '.js'),
  //   () => {
  //     // Load aspnet-validation if not loaded yet
  //     // Use a delay to make sure it doesn't conflict with Umbraco Forms' version of aspnet-validation
  //     window.setTimeout(() => {
  //       if (typeof window.aspnetValidation !== 'object') {
  //         ljs.load(
  //           '/scripts/dist/aspnet-validation.min.js',
  //           util.getVersionedUrl('/scripts/dist/forms.validation.min.js'),
  //           () => {}
  //         );
  //       }
  //     }, 2000);
  //   }
  // );

  if (document.querySelectorAll('[data-comparison-table]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/dialog' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.comparisonTable' + min + '.js'),
      () => {
        app.comparisonTable.init();
      }
    );
  }

  if (document.querySelectorAll('[data-generic-form]').length > 0) {
    window.setTimeout(() => {
      if (typeof window.aspnetValidation !== 'object') {
        ljs.load(
          util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
          util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
          util.getVersionedUrl('/scripts/dist/forms.generic' + min + '.js'),
          () => {
            app.genericForm.init();
          }
        );
      } else {
        ljs.load(util.getVersionedUrl('/scripts/dist/forms.generic' + min + '.js'), () => {
          app.genericForm.init();
        });
      }
    }, 1000);
  }

  if (document.querySelectorAll('[data-sidebar-nav]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.sidebarNav' + min + '.js'), () => {
      app.sidebarNav.init();
    });
  }

  if (document.querySelectorAll('[data-image-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/lightbox' + min + '.js'), () => {
      const buttons = document.querySelectorAll('[data-image-lightbox]');
      buttons.forEach((button) => {
        HtmlLightbox(button, {
          maxWidth: 1600,
          html: `<img src="${button.href}" class="lightbox__image" alt="">`,
        });
      });
    });
  }

  if (document.querySelectorAll('[data-locations]').length > 0) {
    let locationsLoaded = false;

    document.addEventListener('lazybeforeunveil', (event) => {
      if (locationsLoaded === false && event.target.getAttribute('data-locations') === 'true') {
        ljs.load(
          'https://unpkg.com/mustache@4.2.0/mustache' + min + '.js',
          util.getVersionedUrl('/scripts/dist/jsonpath' + min + '.js'),
          util.getVersionedUrl('/scripts/dist/modules.locations' + min + '.js'),
          () => {
            app.locations.init();
            locationsLoaded = true;
          }
        );
      }
    });
  }

  if (document.querySelectorAll('[data-hero-filter]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.heroFilter' + min + '.js'), () => {
      app.heroFilter.init();
    });
  }

  // Initialize lazySizes here to make sure all the event listeners are set up
  if (typeof lazySizes === 'object') {
    lazySizes.init();
  }
});
